import PropTypes from 'prop-types'
import React, { Fragment, PureComponent } from 'react'
import withStyles from 'react-jss'
import responsiveComponent from '../hoc/responsiveComponent'
import loadable from '@loadable/component'
import { sortPhotosByPosition } from '../config/dataConf'
import classnames from 'classnames'
const ReactIcons = loadable.lib(() => import('react-icons/fa'))

const styles = theme => ({
  cadreWrapper: {
    border: props => (props.isMobile ? 'none' : '2px solid'),
    borderColor: props => (props.isMobile ? 'none' : theme.borderColorImage),
    textAlign: 'center',
    userSelect: 'none' /* supported by Chrome and Opera */,
    webkitUserSelect: 'none' /* Safari */,
    khtmlUserSelect: 'none' /* Konqueror HTML */,
    mozUserSelect: 'none' /* Firefox */,
    msUserSelect: 'none' /* Internet Explorer/Edge */
  },
  imageContainer: {
    textAlign: 'center',
    height: props => (props.isMobile ? 300 : 'inherit')
  },
  image: {
    width: props => (props.isMobile ? 'inherit' : '100%'),
    maxWidth: '100%',
    maxHeight: '100%'
  },
  center: {
    display: 'inline-block'
  },
  infoZone: {
    position: 'relative',
    fontSize: theme.taillePetitTexte,
    color: theme.textColorLegendImage,
    padding: props => (props.isMobile ? '10px 40px' : '5px 30px')
  },
  arrow: {
    position: 'absolute',
    top: '20%',
    fontSize: props => (props.isMobile ? 30 : 20),
    '&:hover': {
      cursor: 'pointer'
    }
  },
  arrowLeft: {
    left: 5
  },
  arrowRight: {
    right: 5
  }
})

class Carousel extends PureComponent {
  state = {
    indexImage: 0,
    indexMax: 0
  }

  componentDidMount() {
    this.setState({ indexMax: this.indexMax() })
  }

  // eslint-disable-next-line no-undef
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.indexMax !== this.indexMax()) {
      this.setState({ indexMax: this.indexMax() })
    }
  }

  indexMax = () => (this.props.photos ? this.props.photos.length - 1 : 0)

  next = () => {
    this.setState({
      indexImage:
        this.state.indexImage === this.state.indexMax
          ? 0
          : this.state.indexImage + 1
    })
  }

  previous = () => {
    this.setState({
      indexImage:
        this.state.indexImage === 0
          ? this.state.indexMax
          : this.state.indexImage - 1
    })
  }

  render() {
    const { photos, classes, className } = this.props
    const { indexImage, indexMax } = this.state

    if (photos) {
      photos.sort(sortPhotosByPosition)
    }

    return (
      <div className={classnames(classes.cadreWrapper, className)}>
        {photos && (indexMax !== 0 || photos[indexImage].legende) && (
          <div className={classes.infoZone}>
            {indexMax !== 0 && (
              <ReactIcons>
                {({ FaArrowCircleLeft }) => (
                  <FaArrowCircleLeft
                    className={`${classes.arrow} ${classes.arrowLeft}`}
                    onClick={this.previous}
                  />
                )}
              </ReactIcons>
            )}

            <div className={classes.center}>
              {/* Pour la légende de l'image en cours */}
              {photos && photos[indexImage].legende && (
                <Fragment>
                  <span>{photos[indexImage].legende}</span>
                  <br />
                </Fragment>
              )}

              {/* numéro de la photo à afficher */}
              {indexMax !== 0 && (
                <span>{`${indexImage + 1} / ${indexMax + 1}`}</span>
              )}
            </div>
            {indexMax !== 0 && (
              <ReactIcons>
                {({ FaArrowCircleRight }) => (
                  <FaArrowCircleRight
                    className={`${classes.arrow} ${classes.arrowRight}`}
                    onClick={this.next}
                  />
                )}
              </ReactIcons>
            )}
          </div>
        )}
        {/* Pour les images */}
        <div className={classes.imageContainer}>
          {photos ? (
            <img
              src={photos[indexImage].cloudPath}
              alt={photos[indexImage].legende}
              className={classes.image}
            />
          ) : (
            <img src='/img/no_photo.jpg' alt='' className={classes.image} />
          )}
        </div>
      </div>
    )
  }
}

Carousel.propTypes = {
  className: PropTypes.string,
  photos: PropTypes.array
}

export default responsiveComponent(withStyles(styles)(Carousel))
